/*
 * File: TeamDetailsTab.tsx
 * Project: a-a
 * File Created: Monday, 20th January 2025 7:46:07 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 11th May 2026 10:44:06 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomCard from '../../shared/CustomCard/CustomCard';
import { Link, useParams } from 'react-router-dom';
import zeplinColor from '../../../theme/Color';

import CustomButton from '../../shared/CustomButton/CustomButton';
import { ClientService } from '../../../service/client.service';
import CustomLoader from '../../shared/CustomLoader/CustomLoader';
import KeyMatrixCard from './KeyMatrixCard';
import TeamDetailsCard from './TeamDetailsCard';
import { TeamService } from '../../../service/team.service';
import style from './TeamDetailsTab.module.css';
import { usePermissions } from 'customHook/usePermissions';
type DealType = {
  closedDealsLastQuarter: number | null;
  closedDealsThisQuarter: number | null;
  closedTasksDelta: string | null;
  closedTasksLastQuarter: number | null;
  closedTasksThisQuarter: number | null;
  closeddealsDelta: string | null;
  openDealsDelta: string | null;
  openDealsLastQuarter: number | null;
  openDealsThisQuarter: number | null;
  openTasksThisQuarter: number | null;
};
const TeamDetailsTab = () => {
  const screenHeight = window.innerHeight;
  const params = useParams();
  const { hasAction } = usePermissions();
  const canCreateDeal = hasAction('Deals', 'AllDeals', 'create');
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = React.useState<DealType>({
    closedDealsLastQuarter: 0,
    closedDealsThisQuarter: 0,
    closedTasksDelta: '',
    closedTasksLastQuarter: 0,
    closedTasksThisQuarter: 0,
    closeddealsDelta: '',
    openDealsDelta: '',
    openDealsLastQuarter: 0,
    openDealsThisQuarter: 0,
    openTasksThisQuarter: 0,
  });
  // const [selected, setSelected] = React.useState<DealType>();
  // console.log(selected);
  let processedData = [
    {
      label: 'Quaterly Close Deals',
      value: details?.closedDealsThisQuarter ?? 0,
      delta: details?.closeddealsDelta,
    },
    {
      label: 'Quaterly Open Deals',
      value: details?.openDealsThisQuarter ?? 0,
      delta: details?.openDealsDelta,
    },
    {
      label: 'Quarterly Completed Tasks',
      value: details?.closedTasksThisQuarter ?? 0,
      delta: details?.closedTasksDelta,
    },
    { label: 'Quarterly Open Tasks', value: details?.openTasksThisQuarter ?? 0, delta: '' }, // No delta
  ];
  const getKeyDeals = async (id: string) => {
    setLoading(true);
    try {
      if (id) {
        const res = await TeamService.getMemberKeyDeals(id);
        const deals = res;
        console.log(res);
        if (deals) {
          // setSelected(deals[0]);
          setDetails(deals);
        }
      }
    } catch (err: any) {
      console.log(err, 'errdeal');
      // setAlert(err?.message as string);
    } finally {
      setLoading(false);
    }
  };

  const deals = Object.entries(details);

  useEffect(() => {
    getKeyDeals(params?.id || '');
  }, []);
  return (
    <Box sx={{ height: { xs: 'calc(100vh - 300px)', xl: 'calc(100vh - 320px)' } }}>
      {' '}
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            gap: '20px',
            height: { xs: 'calc(100vh - 300px)', xl: 'calc(100vh - 320px)' },
            overflowY: 'hidden',
          }}
        >
          <Box sx={{ flex: 1, overflowY: 'hidden' }}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((val: any, ind: number) => (
              <KeyMatrixCard data={val} title={val?.label} delta={val?.delta} loading={true} />
            ))}
          </Box>
          <Box
            sx={{
              flex: 2,
              height: { xs: 'calc(100vh - 300px)', xl: 'calc(100vh - 320px)' },
              // paddingBottom: '22rem',
            }}
          >
            <TeamDetailsCard loading={true} />
          </Box>
        </Box>
      ) : deals.length ? (
        <>
          {/* <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          ></Box> */}
          <Box sx={{ display: 'flex', gap: '20px' }}>
            <Box sx={{ flex: 1 }}>
              {' '}
              <Typography variant='responsiveHeading3'>Key Matrix</Typography>
              <Box
                sx={{
                  overflowY: 'scroll',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  position: 'relative',
                  height: { xs: 'calc(100vh - 300px)', xl: 'calc(100vh - 320px)' },
                  // paddingBottom: { xs: '10rem', xl: '30rem' },
                  // window.innerHeight - 270,
                  // screenHeight > 800
                  //   ? '56vh'
                  //   : screenHeight > 650
                  //   ? '50vh'
                  //   : screenHeight > 500
                  //   ? '35vh'
                  //   : '32vh',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                {processedData?.map((val: any) => (
                  <Box>
                    {' '}
                    <KeyMatrixCard data={val?.value} title={val?.label} delta={val?.delta} />{' '}
                  </Box>
                ))}
              </Box>
            </Box>
            <Box
              sx={{
                flex: 2,
                // height:
                //   screenHeight > 800
                //     ? '56vh'
                //     : screenHeight > 650
                //     ? '54vh'
                //     : screenHeight > 500
                //     ? '35vh'
                //     : '32vh',
                height: '100vh',
                paddingBottom: '22rem',
              }}
            >
              <TeamDetailsCard />
            </Box>
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
            height: screenHeight > 640 ? '55vh' : screenHeight > 500 ? '41vh' : '39vh',
            gap: '32px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // flex: 1,
              gap: '12px',
            }}
          >
            <img src={'/assets/no-keydeals.svg'} className={style.noKeyDealsImage} />
            <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
              No Deals Available
            </Typography>
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
              Create new deals to keep track of client opportunities and activities.
            </Typography>
          </Box>
          <Link
            to={`https://${process.env.REACT_APP_SALESFORCE_URI}/lightning/r/Account/${params?.id}/related/Opportunities/view`}
            target='_blank'
            rel='noopener noreferrer'
            style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
          >
            <CustomButton
              disabled={!canCreateDeal}
              onClick={() => {}}
              variant='outlined'
              color='secondary'
              style={{
                // width: '40%',
                borderRadius: 14,
                height: 56,
                backgroundColor: zeplinColor.Brand1,

                // gap: '16px',
                padding: '14px 16px',
              }}
              textStyle={{ color: zeplinColor.Neutral1 }}
              text={'Create Deals'}
            />
          </Link>
        </Box>
      )}
      {/* {loading ? (
        <CustomLoader
          open={loading}
          handleCloseModal={() => {
            setLoading(false);
          }}
        />
      ) : (
        ''
      )} */}
      {/* </Box> */}
    </Box>
  );
};

export default TeamDetailsTab;
